import $ from 'jquery';

$(function () {
    if ($('.preferencecentrepage').length) {

        $('#unsubscribe').on('change', function () {
            if ($(this).prop('checked')) {
                $('input[type=checkbox][name=preference]').prop('checked', false);
            }
        });

        $('input[type=checkbox][name=preference]').on('change', function () {
            if ($('#unsubscribe').prop('checked') && $(this).prop('checked')) {
                $('#unsubscribe').prop('checked', false);
            }
        });
    }
});